import React from "react";
import { dateFormatter } from "utils/formatUtils";
import RfqSubProjectsSummary from "components/RfqSubProjectsSummary";

const statusColor = {
  closed: "#FDE8E8",
  deleted: "#00FFFF",
  canceled: "#808080",
  hold: "#800080",
  open: "#BFFFBA",
  draft: "#FFFCB1",
  expired: "#9B1C1C",
  trash: "#9B1C1C",
  rework: "#D9F99D",
  'pending approval': "#FAD7A0"
};

const OverviewInfo = ({ data }) => {
  const capitalizeFirstLetter = (string) => {
    if (!string) return "";
    return string.charAt(0).toUpperCase() + string.slice(1).toLowerCase();
  };

  // Check for multiple projects and locations
  const hasMultipleProjects = data?.projectName?.includes('||');
  const siteLocation = data?.projectSiteAddress || data?.location;
  const hasMultipleLocations = siteLocation?.includes('||');

  // Split into arrays if multiple exist
  const projects = hasMultipleProjects ? data.projectName.split('||') : [data?.projectName];
  const locations = hasMultipleLocations ? siteLocation.split('||') : [siteLocation];

  const mappingData = [
    {
      label: "RFQ Subject",
      value: data?.name,
    },
    {
      label: "Requirement Type",
      value: capitalizeFirstLetter(data?.rfqType),
    },
    {
      label: "Status",
      value: (
        <div className="flex items-center gap-x-1">
          <div
            className="p-2 rounded-full border-solid"
            style={{
              borderWidth: "0.5px",
              background: statusColor[data?.status.toLowerCase()],
            }}
          />
          {data?.status}
        </div>
      ),
    },
    {
      label: "Created Date",
      value: data?.createdAt ? dateFormatter(data?.createdAt) : "NA",
    },
    {
      label: "Indent Number",
      value: data?.parentsRefId ? data?.parentsRefId : "NA",
    },
    {
      label: hasMultipleProjects ? "Multiple Projects" : "Project Name",
      value: (
        <div className="flex flex-col gap-1">
          {projects.map((project, index) => (
            <div key={`project-${index}`} className="text-xs">
              {project.trim() || "NA"}
            </div>
          ))}
        </div>
      ),
    },
    {
      label: hasMultipleLocations ? "Multiple Locations" : "Project Location",
      value: (
        <div className="flex flex-col gap-1">
          {locations.map((loc, index) => (
            <div key={`location-${index}`} className="text-xs">
              {loc.trim() || "NA"}
            </div>
          ))}
        </div>
      ),
    },
    {
      label: "Category",
      value: data?.businessDivision ? data?.businessDivision : "NA",
    },
    ...(data?.rfqBudget
      ? [
        {
          label: "RFQ Budget",
          value: `Rs. ${new Intl.NumberFormat("en-IN").format(Number(data.rfqBudget) || 0)}`,
        },
      ]
      : []),
  ];

  const getStyledSet = (label, value, index) => (
    <div key={label + index} className="">
      <p className="block text-xs font-normal text-[#6B7280]">{label}</p>
      <b className="text-[#111928] text-xs">{value}</b>
    </div>
  );

  return (
    <div className="w-full" style={{ fontFamily: "goldman_sans" }}>
      <div className="grid grid-cols-3 gap-4">
        <h2 className="text-gray-900 text-sm font-bold mb-1 col-span-3">
          General Information
        </h2>
        {mappingData?.map((item, index) =>
          getStyledSet(item.label, item.value, index)
        )}
      </div>
      <RfqSubProjectsSummary subProjects={data?.subProjects} />
    </div>
  );
};

export default OverviewInfo;
